const config = {
    api_base_url: "https://royaltiesapi.orbmusic.com.br",
    site_base_url: "https://royalties.orbmusic.com.br",
    orb_profile_url: "https://auth.orbmusic.com.br/profile",
    orb_logout_url: "https://auth.orbmusic.com.br/logout?app=1239215190f6498751aa0affc0a9c22a63cdaabd4b4a7e87851b3382288c9a3b",
    orb_auth_url: "https://auth.orbmusic.com.br?app=1239215190f6498751aa0affc0a9c22a63cdaabd4b4a7e87851b3382288c9a3b",
    // Configuração de paginação padrão
    default_page_size: 10,
}

export default config;